export default {
  none: 0,
  red: 1,
  blue: 2,
  green: 3,
  yellow: 4,
};
